const PopupTypes = {
  PAYFAIL: 'PAYFAIL',
  TESCO: 'TESCO',
  RAC_LOYALTY_REWARDS: 'RAC_LOYALTY_REWARDS',
  RENEW_NOW: 'RENEW_NOW',
  EFULFILMENT: 'EFULFILMENT',
  APP_MERCHANDISE: 'APP_MERCHANDISE',
  NONE: 'NONE',
}

export default PopupTypes;
